import Particles from '../atoms/Particles'

type Props = {
  title: string
  uptitle: string
}

const ParticleHeader = ({ title, uptitle }: Props) => {
  const titleWords = title.split(' ')
  return (
    <div className="relative text-center py-28 -mx-4 md:-mx-8  lg:mx-40 z-10">
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none -z-50">
        <Particles />
      </div>
      <div className="max-w-prose mx-auto">
        <h2 className="z-10 text-md lg:text-lg lg:leading-loose leading-loose">
          {uptitle}
        </h2>
        <h1 className="z-10 text-3xl font-medium leading-relaxed lg:text-6xl lg:leading-snug">
          {titleWords.map((word) => (
            <span className="first:ml-3 inline-block mr-3 last:mr-0" key={word}>
              {word}
            </span>
          ))}
        </h1>
      </div>
    </div>
  )
}

export default ParticleHeader
